import ready from "../components/_ready"
import { tns } from 'tiny-slider';
import 'tiny-slider/dist/tiny-slider.css';

ready(() => {
  const startIndex = [
      ...document
      .querySelectorAll('.primary-menu-slider .nav-item a')
      .values()
    ]
    .findIndex((el) => el.classList.contains('primary'));
  tns({
    container: '.primary-menu-slider',
    prevButton: '.slider-controls .prev-btn',
    nextButton: '.slider-controls .next-btn',
    slideBy: "page",
    startIndex: startIndex >= 0 ? startIndex : 0,
    items: 3,
    autoWidth: true,
    nav: false,
    loop: false,
    gutter: 10,
  });
});
